import type { AdImage } from 'shared/components/imageGallery/types';

import type { Hotel } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

type TranslatedAmenities = {
    amenitiesList: string[];
    amenitiesInline: string;
};

export const getTranslatedAmenities = (hotel: Hotel): TranslatedAmenities => {
    const translatedFacilities = (hotel.facilities ?? [])
        .map((key) => displayValues.amenities.facilities[key])
        .filter((value): value is string => Boolean(value));

    const translatedActivities = (hotel.activities ?? [])
        .map((key) => displayValues.amenities.activities[key])
        .filter((value): value is string => Boolean(value));

    const amenitiesList = [...translatedFacilities, ...translatedActivities];

    return {
        amenitiesList,
        amenitiesInline: amenitiesList.join(' • '),
    };
};

export const getHotelFullDescription = (hotel: Hotel, amenitiesList: string[]): string =>
    `${hotel.name}, ${hotel.destination}, ${hotel.region}, ${hotel.country}, ${hotel.rating} stjerne, ${amenitiesList.join(
        ', ',
    )}, ${hotel.distanceToBeach} meter fra strand, ${hotel.distanceToCity} meter fra sentrum`;

export const getDestinationCollection = (hotel: Hotel): string =>
    [hotel.destination, hotel.region, hotel.country].filter(Boolean).join(' / ');

export const mapHotelImages = (imagePaths: string[] | undefined | null, imgPath: string): AdImage[] =>
    (imagePaths ?? []).map((p) => ({
        uri: `${imgPath}1280w${p}`,
        width: 1280,
        height: 720,
    }));
